<!--
 * @Description: 使用 — 入门篇2;
 * @Author: CcSimple
 * @Github: https://github.com/CcSimple
 * @Date: 2023-02-07 11:52:50
 * @LastEditors: CcSimple
 * @LastEditTime: 2023-02-11 15:50:41
-->
<template>
  <div class="flex-col main">
    <!-- dialog -->
    <PublicDialog :dialogData="dialogData">
      <template #AddTemplate>
        <el-form :model="AddTemplateForm" :rules="AddTemplateRules" ref="AddTemplateRef" label-position="top">
          <el-row :gutter="20">
            <el-col :span="16" :offset="4">
              <el-form-item label="模板名称" prop="templateName">
                <el-input v-model="AddTemplateForm.templateName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </PublicDialog>
    <!-- <div class="flex-row justify-center" style="margin-bottom: 10px">
      <button class="secondary circle-10 ml-10" @click.stop="getHtml" v-show="isTem">
        <i class="iconfont sv-preview" />
        预览
      </button>
    </div> -->
    <div class="flex-row justify-center" style="margin-bottom: 10px">
      <div class="selectTemplate" style="margin-left:10px;">
        <el-button type="primary" icon="el-icon-plus" style="fontSize:14px;background:#18B3C6;" @click="handleClickAddTemplate">新增模板</el-button>
      </div>
      <div class="selectTemplate">
        <el-select size="medium" v-model="checkedTemplateId" placeholder="请选择打印模板" @change='checkedTemplateIdChange'>
          <el-option
            v-for="item in templateOptions"
            :key="item.id"
            :label="item.templateName"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <el-divider v-if="!isTem"></el-divider>
      <!-- 纸张大小 A3、A4 等 -->
      <div class="paper" v-show="isTem">
        <template>
          <button v-for="(value, type) in stateTwo.paperTypes" :key="type" :class="curPaperType() === type ? 'api' : 'info'" @click="setPaper(type, value)">
            {{ type+'纸' }}
          </button>
        </template>
        <!-- 自定义纸张 -->
        <button v-show="isTem" :class="'other' == curPaperType() ? 'api' : 'info'" class="auto" @click="showPaperPop">自定义纸张</button>
        <div class="popover">
          <div class="popover-content flex-col" v-show="stateTwo.paperPopVisible">
            <div style="font-size: 16px; font-weight: bold">设置纸张宽高(mm)</div>
            <div class="flex-row mt-10">
              <input class="input" v-model.number="stateTwo.paperWidth" type="number" placeholder="宽(mm)" />
              <span class="ml-10 mr-10">x</span>
              <input class="input" v-model.number="stateTwo.paperHeight" type="number" placeholder="高(mm)" />
            </div>
            <button class="primary circle-10" style="margin-top: 6px" @click.stop="setPaperOther">确定</button>
          </div>
        </div>
      </div>
      <!-- 缩放 -->
      <div v-show="isTem" class="flex-row align-center ml-10">
        <button class="info circle-10" @click="changeScale(false)"><i class="iconfont sv-zoom-out" /></button>
        <div style="margin: 0 4px; width: 40px">{{ (state.scaleValue * 100).toFixed(0) }}%</div>
        <button class="info circle-10" @click="changeScale(true)"><i class="iconfont sv-zoom-in" /></button>
      </div>
      <button v-show="isTem" class="api circle-10 ml-10" @click.stop="rotatePaper">
        <i class="iconfont sv-rotate" />
        旋转纸张
      </button>
      <button v-show="isTem" class="api circle-10 ml-10" @click.stop="clearPaper">
        <i class="iconfont sv-clear" />
        清空纸张
      </button>
      <button v-show="isTem" class="api circle-10 ml-10" @click.stop="exportJson(false)">
        <i class="iconfont sv-export" />
        保存模板
      </button>
      <div class="selectTemplate" style="margin-left:10px;" v-show="isTem">
        <span style="margin:0 5px;">自动保存间隔&emsp;&emsp;&emsp;:&emsp;&emsp;&emsp;</span>
        <el-select size="medium" v-model="autoSaveValue" placeholder="请选择自动保存间隔" @change='autoSaveValueChange'>
          <el-option
            v-for="item in [
            {id:1,label:'1分钟',value:1},
            {id:2,label:'3分钟',value:3},
            {id:3,label:'5分钟',value:5},
            {id:4,label:'从不',value:0}
            ]"
            :key="item.id"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <!-- <button class="api circle-10 ml-10" @click.stop="exportJsonTid">
        导出模板 json tid
        <i class="iconfont sv-export" />
      </button> -->
      <!-- <button class="secondary circle-10 ml-10" @click.stop="print">
        <i class="iconfont sv-printer" />
        浏览器打印
      </button> -->
      <!-- <button class="warning circle-10 ml-10" @click.stop="print2">
        直接打印(需要连接客户端)
        <i class="iconfont sv-printer" />
      </button> -->
    </div>
    <div class="flex-row" style="height: 85vh" v-show="isTem">
      <div class="flex-2 left flex-col">
        <div class="title">自定义组件</div>
        <!-- provider1 的容器; 加上 class "rect-printElement-types" 使用默认样式 -->
        <!-- 当然可以 重写 或者 自定义样式 -->
        <div id="providerData-container1" class="container rect-printElement-types"></div>
        <div class="title">基础组件</div>
        <!-- provider2 的容器; -->
        <!-- 这里自定义显示样式 custom-style-types -->
        <div id="providerData-container2" class="container custom-style-types"></div>
        <div class=""></div>
      </div>
      <div class="flex-5 center">
        <!-- 设计器的 容器 -->
        <div id="hiprint-printTemplate"></div>
      </div>
      <div class="flex-2 right">
        <!-- 元素参数的 容器 -->
        <div id="PrintElementOptionSetting"></div>
      </div>
    </div>
    <start-preview ref="preview" />
    <el-skeleton v-show="!isTem">
    <template slot="template">
      <el-skeleton-item variant="p" style="width: 50%;overflow:hidden;margin:10px 0;" />
      <el-skeleton-item variant="p" style="width: 100%;overflow:hidden;margin:10px 0;" v-for="item in 4" :key="item+'a'"/>
      <div class="skeletonBox" style="width:100%;display:flex;align-items: center;justify-content: space-between;">
        <div style="width:35%;">
          <el-skeleton-item variant="p" style="width: 100%;overflow:hidden;margin:10px 0;"  v-for="item in 7" :key="item+'b'"/>
        </div>
        <div style="width:30%;"> 
          <el-empty
            description="请先选择打印模板"
          ></el-empty>
        </div>
        <div style="width:35%;">
          <el-skeleton-item variant="p" style="width: 100%;overflow:hidden;margin:10px 0;"  v-for="item in 7" :key="item+'c'"/>
        </div>
      </div>
      <el-skeleton-item variant="p" style="width: 100%;overflow:hidden;margin:10px 0;" v-for="item in 6" :key="item+'d'"/>
      <el-skeleton-item variant="p" style="width: 80%;overflow:hidden;margin:10px 0;" />
    </template>
  </el-skeleton>
  </div>
</template>

<script>
// import { onMounted, ref, getCurrentInstance } from "vue";
import { hiprint ,disAutoConnect} from "vue-plugin-hiprint";
disAutoConnect();
import { provider1 } from "./configData/provider1";
import { provider2 } from "./configData/provider2";
import template from "./configData/template";
import printData from "./configData/printData";
import domConfig from './configData/domConfig'
import fontSize from "./hooks/fontSize";
import lineHeight from "./hooks/lineHeight";
import textAlign from "./hooks/textAlign";
import textContentVerticalAlign from "./hooks/textContentVerticalAlign";
import {getModuleParamsApi,getPaperSizeApi,saveTemplateApi,allJiaBoApi} from '@/api/print_template_test';
import startPreview from "./preview.vue";

// 工具
import { newHiprintPrintTemplate ,getHiprintPrintTemplate} from "@/utils/template-helper";
export default {
  components: {
    startPreview
  },
  data(){
    return{
      timer:null,
      autoSaveValue:5,
      isTem:false,
      checkedTemplateId:null,
      templateOptions:[],
      state:{
        scaleValue: 1,
        scaleMax: 5,
        scaleMin: 0.5,
      },
      stateTwo: {
        // curPaper: {
        //   type: "test",
        //   width: 80,
        //   height: 190,
        // },
        // paperTypes: {
        //   test: {
        //     width: 80,
        //     height: 190,
        //   },
        //   A3: {
        //     width: 420,
        //     height: 296.6,
        //   },
        //   A4: {
        //     width: 210,
        //     height: 296.6,
        //   },
        //   A5: {
        //     width: 210,
        //     height: 147.6,
        //   },
        //   B3: {
        //     width: 500,
        //     height: 352.6,
        //   },
        //   B4: {
        //     width: 250,
        //     height: 352.6,
        //   },
        //   B5: {
        //     width: 250,
        //     height: 175.6,
        //   },
        // },
        // // 自定义纸张
        // paperPopVisible: false,
        // paperWidth: "80",
        // paperHeight: "190",
      },
      name: "start-02",
      TEMPLATE_KEY:'',
      hiprintTemplate:'',
      templateRef:{},
      // dialog数据源
      dialogData: [
        {
          data: [], // 传递数据slot
          name: "AddTemplate", // dialog插槽名
          key: "AddTemplate", // 区分唯一性key
          isDialog: false, // 是否显示dialog
          isBtn: true, // 是否显示cancel和confirm按钮
          title: "新增模板", // header提示内容
          width: "500px", // dialog宽度
          // lockScroll: true,
          // closeModal: false,
          // closePressEscape: false,
          // showClose: false,
          cancelBtnName: "取消",
          confirmBtnName: "确定",
          colseFn: this.closeFnAddTemplate,
          // handleClickCancel: this.handleClickCustomizationCancel, // dialog取消
          handleClickConfirm: this.handleClickAddTemplateConfirm, // dialog确定
        },
      ],
      AddTemplateForm: {
        templateName: '',
        templateContent:JSON.stringify({
            "pxToPt": 2.85,
            "index": 0,
            "name": 1,
            "paperType": "test",
            "height": 150,
            "width": 90,
            // "paperHeader": 0,
            // "paperFooter": 841.8897637795277,
            "printElements": [],
            "paperNumberContinue": true,
            "watermarkOptions": {},
            "paperNumberFormat":" "
        }),
        isAutoSave:true,
        saveIntervalTime:5
      },
      AddTemplateRules: {
        templateName: [{ required: true, message: '请输入模板名称', trigger: ['blur','change'] },],
      }
    }
  },
  created () {
    this.templateQuery();
    this.paperSizeQuery();
    this.moduleParamsQuery();
  },
  beforeDestroy () {
    if(this.timer) clearInterval(this.timer)
    if(this.isTem){
      this.exportJson(true)
    }
    // console.log(window.HIPRINT_CONFIG)
  },
  methods: {
    // getHtml(){
    //   let html = this.hiprintTemplate.getHtml([this.templateRef,this.templateRef]);
    //   this.$refs.preview.showModal(html);
    // },
    moduleParamsQuery(){
      getModuleParamsApi()
      .then(res=>{
        this.TEMPLATE_KEY = this.name; // 存储模板对象的 key
        // 初始化 providerData
        hiprint.init({
          providers: [this.getProvider(res,'providerModule1'),this.getProvider(res,'providerModule2')],
        });
        hiprint.setConfig(JSON.parse(JSON.stringify(domConfig)));
        /**
         * 这里必须要在 onMounted 中去构建 左侧可拖拽元素 或者 设计器
         * 因为都是把元素挂载到对应容器中, 必须要先找到该容器
         */
        this.buildLeftElement();
        this.buildDesigner();
      })
    },
    paperSizeQuery(){
      getPaperSizeApi()
      .then(res=>{
        let result=res&&res[0]?.modules;
        let handleResult=result&&result[0];
        this.stateTwo=handleResult||{};
      })
    },
    templateQuery(){
      allJiaBoApi()
      .then(res=>{
        this.templateOptions=res||[];
      })
    },
    closeFnAddTemplate() {
      this.$refs.AddTemplateRef&&this.$refs.AddTemplateRef.resetFields();
    },
    handleClickAddTemplateConfirm(item, index) {
      this.$refs.AddTemplateRef.validate((valid) => {
        if (valid) {
          saveTemplateApi(this.AddTemplateForm)
          .then(res=>{
            this.$message({type:'success',message:'新增模板成功'})
          })
          .catch(err=>{
            this.$message({type:'error',message:err.message})
          })
          .finally(()=>{
            this.dialogData[index].isDialog = false;
            this.templateQuery();
          })
        } else {
          return false;
        }
      });
    },
    handleClickAddTemplate(){
      this.dialogData[0].isDialog = true;
    },
    autoSaveValueChange(val){
      if(this.timer) clearInterval(this.timer)
      if(!val) return
      this.timer=setInterval(() => {
        this.exportJson(true)
      }, val*60*1000);
    },
    checkedTemplateIdChange(id){
      let val=this.templateOptions.find(item=>item.id===id)||{};
      this.autoSaveValue=val?.saveIntervalTime||0;
      this.isTem=true;
      this.autoSaveValueChange(this.autoSaveValue);

      this.templateRef={panels:[JSON.parse(val?.templateContent)]};
      this.buildDesigner()
    },
    getProvider(providerData,elementName) {
      var addElementTypes = function (context) {
        context.removePrintElementTypes(elementName);
        let arr=providerData&&providerData.filter(item=>item.layoutKey===elementName);
        let result= arr&&arr.map(item=>(new hiprint.PrintElementTypeGroup(item.layoutName, item.modules)));
        context.addPrintElementTypes(elementName, result);
      };
      return {
        addElementTypes: addElementTypes,
      };
    },
    // 计算属性
    curPaperType () {
      let type = "other";
      let types = this.stateTwo.paperTypes;
      for (const key in types) {
        let item = types[key];
        let { width, height } = this.stateTwo.curPaper;
        if (item.width === width && item.height === height) {
          type = key;
        }
      }
      return type;
    },
    // 方法
    showPaperPop () {
      this.stateTwo.paperPopVisible = true;
    },
    hidePaperPop () {
      this.stateTwo.paperPopVisible = false;
    },
    setPaper (type, value) {
      try {
        if (Object.keys(this.stateTwo.paperTypes).includes(type)) {
          this.stateTwo.curPaper = { type: type, width: value.width, height: value.height };
          this.tp().setPaper(value.width, value.height);
        } else {
          this.stateTwo.curPaper = { type: "other", width: value.width, height: value.height };
          this.tp().setPaper(value.width, value.height);
        }
      } catch (error) {
        alert(`操作失败: ${error}`);
      }
    },
    setPaperOther () {
      let value = {};
      value.width = this.stateTwo.paperWidth;
      value.height = this.stateTwo.paperHeight;
      this.stateTwo.paperPopVisible = false;
      this.setPaper("other", value);
    },
    // 获取 template
    tp () {
      return getHiprintPrintTemplate(this.TEMPLATE_KEY);
    },
    // 方法
    changeScale (big) {
      let scaleValue = this.state.scaleValue;
      if (big) {
        scaleValue += 0.1;
        if (scaleValue > this.state.scaleMax) scaleValue = 5;
      } else {
        scaleValue -= 0.1;
        if (scaleValue < this.state.scaleMin) scaleValue = 0.5;
      }
      if (this.tp()) {
        // scaleValue: 放大缩小值, false: 不保存(不传也一样), 如果传 true, 打印时也会放大
        this.tp().zoom(scaleValue);
        this.state.scaleValue = scaleValue;
      }
    },
    /**
     * 构建左侧可拖拽元素
     * 注意: 可拖拽元素必须在 hiprint.init() 之后调用
     * 调用之前 可以先 console.log($("#hiprint-printTemplate")) 看看是否有该 dom
     */
    buildLeftElement () {
      // ----- providerModule1 -----
      // eslint-disable-next-line no-undef
      $("#providerData-container1").empty(); // 先清空, 避免重复构建
      // eslint-disable-next-line no-undef
      hiprint.PrintElementTypeManager.build($("#providerData-container1"), "providerModule1");
      // ----- providerModule2 -----
      // eslint-disable-next-line no-undef
      $("#providerData-container2").empty(); // 先清空, 避免重复构建
      // eslint-disable-next-line no-undef
      hiprint.PrintElementTypeManager.build($("#providerData-container2"), "providerModule2");
    },
    /**
     * 构建设计器
     * 注意: 必须要在 onMounted 中去构建
     * 因为都是把元素挂载到对应容器中, 必须要先找到该容器
     */
    buildDesigner () {
      // eslint-disable-next-line no-undef
      $("#hiprint-printTemplate").empty(); // 先清空, 避免重复构建
      // 注意事项: 模板json(object)
      // 如果使用 vue ref创建的模板json, 需要使用 .value 获取 (确保内部能够使用 object.key 拿到对应数据就行)
      this.hiprintTemplate = newHiprintPrintTemplate(this.TEMPLATE_KEY, {
        template: this.templateRef, // 模板json(object)
        settingContainer: "#PrintElementOptionSetting", // 元素参数容器
      });
      // 构建 并填充到 容器中
      this.hiprintTemplate.design("#hiprint-printTemplate",{grid:true});
      hiprint.setConfig({
        // 加载 自定义/重写 的 参数 
        optionItems: [
          fontSize,
          lineHeight,
          textAlign,
          // textContentVerticalAlign
        ]
      })
      // this.hiprintTemplate.setFontList([{value:'SourceHanSansCN-Normal',title:'思源黑体'}])
      // this.hiprintTemplate.addPrintPanel({ width: 100, height: 100 });
      // console.log(this.hiprintTemplate);
    },
    /**
     * 浏览器打印
     */
    print () {
      // 参数: 打印时设置 左偏移量，上偏移量
      let options = { leftOffset: -1, topOffset: -1 };
      // 扩展
      let ext = {
        callback: () => {
          console.log("浏览器打印窗口已打开");
        },
        styleHandler: () => {
          // 重写 文本 打印样式
          return "<style>.hiprint-printElement-text{color:red !important;}</style>";
        },
      };
      // 调用浏览器打印
      this.hiprintTemplate.print(printData, options, ext);
    },
    /**
     * 直接打印: 借助客户端,静默打印(无弹窗直接打印)
     * 注意: 需要先连接客户端
     */
    print2 () {
      if (hiprint.hiwebSocket.opened) {
        this.hiprintTemplate.print2(printData);
      } else {
        alert("请先连接客户端(刷新网页), 然后再点击「直接打印」");
      }
    },
    // ----------------- 模板对象 api 部分 -----------------
    /**
     * 旋转纸张
     */
    rotatePaper () {
      this.hiprintTemplate.rotatePaper();
    },
    /**
     * 清空所有元素
     */
    clearPaper () {
      this.hiprintTemplate.clear();
    },
    /**
     * 导出模板 json
     * 必须确保 this.hiprintTemplate 已成功创建
     */
    exportJson (autoSave) {
      let json = this.hiprintTemplate.getJson();
      let jsonData=json.panels&&json.panels[0];
      console.log(jsonData)
      let val=this.templateOptions.find(item=>item.id===this.checkedTemplateId)||{};
      saveTemplateApi({
        ...val,
        saveIntervalTime:this.autoSaveValue,
        isAutoSave:this.autoSaveValue?true:false,
        templateContent:JSON.stringify({pxToPt:2.85,...jsonData})
      })
      .then(res=>{
        if(!autoSave){
          this.$message({type:'success',message:'保存模板成功'})
          this.autoSaveValueChange(this.autoSaveValue);
        }
      })
      .catch(err=>{
        this.$message({type:'error',message:err.message})
      })
      .finally(()=>{
        this.templateQuery();
      })
      // alert("导出成功! 请查看控制台输出");
    },
    /**
     * 导出模板 json tid
     * 仅导出 options, 不导出 printElementType
     * 必须确保 this.hiprintTemplate 已成功创建
     */
    exportJsonTid () {
      let json = this.hiprintTemplate.getJsonTid();
      let jsonData=json.panels&&json.panels[0]?.printElements;
      console.log(jsonData);
      // alert("导出成功! 请查看控制台输出");
    }
  }
};
</script>

<style scoped>
/* 字体样式 */
@import "./iconfont-style/iconfont.css";

/* 定义全局样式 */
/* 在 main.js 入库文件引入 */
body {
  margin: 0;
}

/* scrollbar */
::-webkit-scrollbar {
  height: 4px;
  width: 4px;
}
::-webkit-scrollbar-corner {
  height: 4px;
  width: 4px;
}
::-webkit-scrollbar-thumb {
  background: purple;
  border-radius: 2px;
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
}
::-webkit-scrollbar-thumb:hover {
  background: purple;
}

/* flex */
.flex-row {
  display: flex;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.align-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}

.flex-1 {
  flex: 1;
}
.flex-2 {
  flex: 2;
}
.flex-3 {
  flex: 3;
}
.flex-4 {
  flex: 4;
}
.flex-5 {
  flex: 5;
}

.ml-10 {
  margin-left: 10px;
}
.mr-10 {
  margin-right: 10px;
}
.mt-10 {
  margin-top: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}

/* button 样式 为了好看点 */
button {
  padding: 10px;
  min-width: 40px;
  color: white;
  opacity: 0.9;
  cursor: pointer;
  border-width: 0;
  border: 1px solid #d9d9d9;
}
button:hover {
  opacity: 1;
}
button i {
  font-size: 16px !important;
}
.circle,
.circle-4 {
  border-radius: 4px !important;
}
.circle-10 {
  border-radius: 10px !important;
}
/* 按钮颜色 */
.primary {
  background: purple;
}
.info {
  color: #000;
  background: none;
}
.info:hover {
  color: purple;
  border-color: purple;
}
.secondary {
  background: #1976d2;
}
.warning {
  background: #d32f2f;
}

/* modal */
.modal {
  padding: 0;
  margin: 0;
}
.modal .mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: #00000073;
}
.modal .wrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  overflow: auto;
  background-color: #00000073;
  outline: 0;
}
.modal .wrap .box {
  position: relative;
  margin: 10% auto;
  width: 40%;
  background: #fff;
  border-radius: 4px;
  z-index: 1001;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}
.modal-box__header {
  padding: 10px 14px;
  border-bottom: 1px solid #e9e9e9;
}
.modal-box__footer {
  text-align: end;
}
.modal-box__footer button {
  min-width: 100px;
}
.modal-box__footer button:not(:last-child) {
  margin-right: 10px;
}
</style>
<style>
.main{
  padding: 10px;
}
.rect-printElement-types .hiprint-printElement-type > li > ul > li {
  /* display: block;
  width: 50%;
  float: left; */
  max-width: 200px;
}
/* 重写默认的一个样式 */
.rect-printElement-types .hiprint-printElement-type > li > ul > li > a {
  color: #2FC9ED !important;
  box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
  border: none;
  max-width: 200px;
}

/* 自定义 providerData 构建样式 */
.custom-style-types .hiprint-printElement-type {
  display: block;
}
.custom-style-types .hiprint-printElement-type {
  padding: 0 0 0 0;
  list-style: none;
}
.custom-style-types .hiprint-printElement-type > li > .title {
  display: block;
  padding: 4px 0px;
  color: black;
  clear: both;
}
.custom-style-types .hiprint-printElement-type > li > ul {
  padding: 0 0 0 0;
  display: block;
  list-style: none;
}
.custom-style-types .hiprint-printElement-type > li > ul > li {
  display: block;
  width: 50%;
  float: left;
  max-width: 200px;
}
.custom-style-types .hiprint-printElement-type > li > ul > li > a {
  padding: 12px 6px;
  color: #2FC9ED;
  text-decoration: none;
  background: #fff;
  /* border: 1px solid #ddd; */
  margin-right: 5px;
  width: 95%;
  max-width: 200px;
  display: inline-block;
  text-align: center;
  margin-bottom: 7px;
  box-sizing: border-box;
  /* border: 1px solid rgba(0, 0, 0, 0.2); */
  border-radius: 4px;
  box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
}
</style>

<style scoped>
/* api按钮 */
.api {
  background: #00acc1;
}
.auto {
  width: auto !important;
}
/* 选择模板 */
.selectTemplate{
  margin: 0 20px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 纸张 */
.paper {
  margin-right: 10px;
}
.paper button:not(class*="auto") {
  width: 60px !important;
}
/* 多个 button 间距 */
.paper button + button {
  margin-left: -1px;
}
.paper button:first-child:last-child {
  border-radius: 4px;
}
/* 两边的 btn 圆角 */
.paper button:first-child:not(:last-child) {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.paper button:last-child:not(:first-child) {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.popover {
  position: absolute;
  margin-top: 10px;
  z-index: 10;
}
.popover .popover-content {
  background: white;
  border-radius: 4px;
  padding: 10px 14px;
  box-shadow: 2px 2px 2px 4px rgb(128 0 128 / 20%);
}
.popover .input {
  height: 24px;
  padding: 2px 4px;
}
.popover .input:hover {
  border-color: rgb(245, 155, 241);
  border-radius: 4px;
}

/* 区域 */
.left {
  background: white;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  box-shadow: 2px 2px 2px 0px rgb(128 0 128 / 20%);
  overflow: auto;
}
.left .container {
  height: 50%;
  overflow: auto;
  padding: 0 10%;
  background: #F7F8F9;
}
.left .container[id*="providerData-container2"] {
  margin-bottom: 10px;
  background: #F7F8F9;
}
.center {
  margin: 0 10px;
  background: white;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  padding: 20px;
  box-shadow: 2px 2px 2px 0px rgb(128 0 128 / 20%);
  overflow: auto;
}
.right {
  background: white;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  padding: 10px 0;
  box-shadow: 2px 2px 2px 0px rgb(128 0 128 / 20%);
  overflow: auto;
}
/* 左侧拖拽元素样式 */
.title {
  font-size: 16px;
  font-weight: 500;
  margin: 4px 0 4px 10px;
}
.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  padding: 4px 10px;
  margin: 10px 8px 4px 8px;
  width: 38%;
  min-height: 60px;
  border-radius: 4px;
  box-shadow: 2px 2px 2px 2px rgba(171, 171, 171, 0.2);
}
.item .iconfont {
  font-size: 1.5rem;
}
.item span {
  font-size: 14px;
}
</style>